export const phoneValidationRules = {
    TG: {
        regex: /^(90|91|92|96)\d{6}$/,
        message: "Numéro togolais invalide (90, 91, 92, 96 + 6 chiffres)"
    },
    BJ: {
        regex: /^(90|91|94|95|96|97)\d{6}$/,
        message: "Numéro béninois invalide"
    },
    NG: {
        regex: /^(70|80|81|90|91)\d{8}$/,
        message: "Numéro nigérian invalide"
    },
    GH: {
        regex: /^(20|23|24|25|26|27|28|50|53|54|55|56|57|59)\d{7}$/,
        message: "Numéro ghanéen invalide"
    },
    CI: {
        regex: /^0[157]\d{8}$/,
        message: "Numéro ivoirien invalide"
    },
    SN: {
        regex: /^(70|75|76|77|78)\d{7}$/,
        message: "Numéro sénégalais invalide"
    },
    CM: {
        regex: /^6\d{8}$/,
        message: "Numéro camerounais invalide"
    }
};

export const defaultPhoneValidation = {
    validate: (value) => {
        const digits = value.replace(/\D/g, '');

        return digits.length >= 8 && digits.length <= 15
            || "Numéro invalide";
    }
};